import { render, staticRenderFns } from "./AdminBoard.vue?vue&type=template&id=0da77486&"
import script from "./AdminBoard.vue?vue&type=script&lang=ts&"
export * from "./AdminBoard.vue?vue&type=script&lang=ts&"
import style0 from "./AdminBoard.vue?vue&type=style&index=0&id=0da77486&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports